import React from 'react';
import RestBanner from '../rest-banner/RestBanner';
import './app.contactus.scss';

function AppContactus(props) {
    return (
        <React.Fragment>
          <RestBanner heading="CONTACT US" img={'./contact_rest.jpg'}/>
          <section id="rest-conactus">
            <div className='container'>
              <div className="row">
                {props.ContactUs && props.ContactUs.slice(0,1).map((ContactUs, index) => (
                  <div className="map" key={index}>
                    <iframe frameBorder="0" draggable={true} style={{ width: "100%", height: "100%"}} src={ContactUs.MAP_URL+ContactUs.API_KEY}></iframe>
                  </div>
                ))}
                <div className="col">
                  {props.ContactUs && props.ContactUs.slice(1,4).map((ContactUs, index) => (
                    <div className="address" key={index}>
                      <h4 className="sub-heading">​{ContactUs.country}</h4>
                      <p>​{ContactUs.address}</p>
                      <p>​{ContactUs.phone}</p>
                      <p>​{ContactUs.email}</p>
                      </div>
                      ))}
                  </div>
                </div>
            </div>
          </section>
        </React.Fragment>
    )
}

export default AppContactus;
